import { z } from 'zod';

import { HISTORICAL_DATA_STATUSES } from '../constants/campaignBuilder.js';
import type {
  BuilderTableColumn,
  BuilderTableRow,
} from '../pages/Builder/types.js';

const BudgetRowsSchema = z.record(
  z.string(),
  z.object({
    suggestedBudget: z.number().nullable(),
    isLocked: z.boolean(),
    tileId: z.string().nullable(),
    type: z.string(),
    parentId: z.string().nullable(),
    dateFrom: z.string().nullable(),
    dateTo: z.string().nullable(),
  }),
);

const CheckHistoricalDataPayloadSchema = z.object({
  totalBudget: z.number(),
  targetKpi: z.null(),
  clientId: z.string(),
  journeyId: z.string(),
  flightStartDate: z.string(),
  flightEndDate: z.string(),
  mediaRows: BudgetRowsSchema,
});

export const CheckHistoricalDataResponseSchema = z.object({
  status: z.enum(HISTORICAL_DATA_STATUSES),
});

export const CheckAvailableMetricsResponseSchema = z.object({
  status: z.number(),
  availableMetrics: z.array(z.string()),
});

const GetPredictivePlanningPayloadSchema = z.object({
  totalBudget: z.number(),
  targetKpi: z.string(),
  clientId: z.string(),
  journeyId: z.string(),
  flightStartDate: z.string(),
  flightEndDate: z.string(),
  mediaRows: BudgetRowsSchema,
});

export const GetPredictivePlanningResponseSchema = z.object({
  mediaRows: z.record(z.string(), z.unknown()),
  totals: z.record(z.string(), z.number()),
  optimizationStatus: z
    .object({
      error: z.unknown().optional(),
      status: z.unknown().optional(),
    })
    .optional(),
});

const MetricOptionItemSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export type BudgetRows = z.infer<typeof BudgetRowsSchema>;
export type CheckHistoricalDataPayload = z.infer<
  typeof CheckHistoricalDataPayloadSchema
>;
export type CheckHistoricalDataResponse = z.infer<
  typeof CheckHistoricalDataResponseSchema
>;
export type CheckAvailableMetricsResponse = z.infer<
  typeof CheckAvailableMetricsResponseSchema
>;
export type GetPredictivePlanningPayload = z.infer<
  typeof GetPredictivePlanningPayloadSchema
>;
export type GetPredictivePlanningResponse = z.infer<
  typeof GetPredictivePlanningResponseSchema
>;
export type MetricOptionItem = z.infer<typeof MetricOptionItemSchema>;

export type PredictiveBudgetFieldProps = {
  value: string | number | null;
  column: BuilderTableColumn;
  row: BuilderTableRow;
};
